import React from "react";
import ReviewCard from "../../components/ReviewCard/ReviewCard";
import { sortByOrderAscending } from "../../../Hospitality/helper/helper";

const HopperRestaurantReviewPage = ({ components }) => {
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperRestaurantReviewPage-header":
                return <div className="HopperRestaurantReviewPage-subheader">{component?.Props?.text}</div>
            case "HopperRestaurantReviewPage-subheader":
                return <div className="HopperRestaurantReviewPage-header">{component?.Props?.text}</div>
            case "HopperRestaurantReviewPage-grid":
                return <div className="HopperRestaurantReviewPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <ReviewCard
                                data={data}
                                key={key} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HopperRestaurantReviewPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HopperRestaurantReviewPage